import { createBrowserRouter } from "react-router-dom";
import Login from "./screen/Login";
import ProtectedRoute from "./api/protectedRoute";
import Dashboard from "./screen/Dashboard";
import Layout from "./components/Layout";
import Users from "./screen/Users";
import Quiz from "./screen/Quiz";
import AddQuiz from "./screen/AddQuiz"
import AddUser from "./screen/AddUser"
import EditQuiz from "./screen/EditQuiz"
import EditUser from "./screen/EditUser"
import EditCategory from "./screen/EditCategory"
import VerifyOtp from "./screen/VerifyOtp";
import SendOtp from "./screen/SendOtp";
import ResetPassword from "./screen/ResetPassword";
import ChangePassword from "./screen/ChangePassword";
import UnderDevelopment from "./components/UnderDevelopment";
import UsersDetails from "./screen/UsersDetails";
import QuizDetails from "./screen/QuizDetails";
import Subscriptions from "./screen/Subscriptions";
import EditSubscription from "./screen/EditSubscription";
import TermsConditions from "./screen/TermsConditions";
import Policy from "./screen/Policy"
import Notifications from "./screen/Notifications";
import Support from "./screen/Support";
import SupportDetails from './screen/SupportDetails';
import UploadBanner from "./screen/UploadBanner";
import Category from "./screen/Category";
import ImageManagement from "./screen/ImageManagement";


const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />
    },
    {
        path: "/send-otp",
        element: <SendOtp />
    },
    {
        path: "/verify-otp",
        element: <VerifyOtp />
    },
    {
        path: "/reset-password",
        element: <ResetPassword />
    },
    {
        path: "/term-condition",
        element:<Policy />
    },
    {
        path: '/dashboard',
        element: <Layout />,
        children: [
            {
                index: true,
                element: <ProtectedRoute element={<Dashboard />} />
            },
            {
                path: 'change-password',
                element: <ProtectedRoute element={<ChangePassword />} />
            },
            {
                path: 'user-management',
                element: <ProtectedRoute element={<Users />} />
            },
            {
                path: 'quiz-management',
                element: <ProtectedRoute element={<Quiz />} />
            },
            {
                path: 'add-quiz',
                element: <ProtectedRoute element={<AddQuiz />} />
            },
            {
                path: 'add-user',
                element: <ProtectedRoute element={<AddUser />} />
            },
            {
                path: 'user-details/:id',
                element: <ProtectedRoute element={<UsersDetails />} />
            },
            {
                path: 'quiz-details/:id',
                element: <ProtectedRoute element={<QuizDetails />} />
            },
            {
                path: 'user-edit/:id',
                element: <ProtectedRoute element={<EditUser />} />
            },
            {
                path: 'category-edit/:id',
                element: <ProtectedRoute element={<EditCategory />} />
            },
            {
                path: 'quiz-edit/:id',
                element: <ProtectedRoute element={<EditQuiz />} />
            },

            {
                path: 'quiz-management',
                element: <ProtectedRoute element={<UnderDevelopment />} />
            },
            {
                path: 'subscription-management',
                element: <ProtectedRoute element={<Subscriptions />} />
            },
            {
                path: 'subscription-edit/:id',
                element: <ProtectedRoute element={<EditSubscription />} />
            },
            {
                path: 'term-conditions',
                element: <ProtectedRoute element={<TermsConditions />} />
            },
            {
                path: 'send-notifications',
                element: <ProtectedRoute element={<Notifications />} />
            },
            {
                path: 'upload-banner',
                element: <ProtectedRoute element={<UploadBanner />} />
            },
            {
                path: 'quiz-support-tools',
                element: <ProtectedRoute element={<ImageManagement />} />
            },
            {
                path: 'image-management',
                element: <ProtectedRoute element={<ImageManagement />} />
            },
            {
                path: 'categories',
                element: <ProtectedRoute element={<Category />} />
            },
            {
                path: 'support-management',
                element: <ProtectedRoute element={<Support />} />
            },
            {
                path: 'support-details/:id',
                element: <ProtectedRoute element={<SupportDetails />} />
            },
        ]
    }
]);
export default router;

